import { useDispatch } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { ScrollComponent } from '../../../../common/scrollComponent'
import { changeDetailsSuggest } from '../store/slice'
import { SelectedItem } from './SelectedItem'

export const SelectedCompany = ({ data }) => {
  const dispatch = useDispatch()

  const onRemoveItem = (item) => {
    dispatch(
      changeDetailsSuggest({
        path: ['dataDetailsSuggest', item?.organizationId, 'check'],
        data: false,
      }),
    )
  }

  return (
    <Element className="flexColumn h100">
      <Element
        className="flexColumn flex1 w100"
        style={{
          backgroundColor: '#FFFFFF',
          borderStyle: 'solid',
          borderWidth: 1,
          borderColor: '#D5D5D5',
        }}
      >
        <Element
          style={{
            padding: '8px 12px',
            borderBottomStyle: 'solid',
            borderBottomColor: '#D5D5D5',
            borderBottomWidth: 1,
          }}
        >
          <Translate
            className="fw600"
            id={'SelectedCompany'}
            value={'companyAnalysis.peerAnalysis.SELECTED_COMPANY'}
            numberSelect={data?.length || 0}
          />
        </Element>
        <ScrollComponent appendStyle={{ flexGrow: 1 }}>
          {data?.map((item, index) => {
            return (
              <SelectedItem
                key={index}
                item={item}
                index={index}
                onRemoveItem={onRemoveItem}
              />
            )
          })}
        </ScrollComponent>
      </Element>
    </Element>
  )
}
